import React, { useState } from 'react';

const Disclaimer = () => {
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(!expanded);

  const briefText =
    'Disclaimer: Genuine persons never ask for money. ';
  const fullText =
    'Disclaimer: Genuine persons never ask for money. If anyone demands money in the name of casting or film roles, they are fake. Do not trust them — report such cases immediately to Hyderabad Casting Club. (7799234563)\n\n' +
    'జెన్యూయిన్ పర్సన్స్ ఎప్పుడూ డబ్బులు అడగరు. ఎవరో క్యాస్టింగ్ లేదా సినిమా రోల్స్ పేరుతో డబ్బులు అడిగితే, వారు ఫేక్. వారిని నమ్మకండి — అలాంటి విషయాలను వెంటనే Hyderabad Casting Club కి రిపోర్ట్ చేయండి. (7799234563)\n\n' +
    'जेनुइन पर्सन्स कभी पैसे नहीं मांगते। अगर कोई कास्टिंग या फिल्म रोल्स के नाम पर पैसे मांगता है, तो वह फेक है। उन पर भरोसा मत करो — ऐसे मामलों की तुरंत Hyderabad Casting Club में रिपोर्ट करो। (7799234563)';

  return (
    <div
      style={{
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        padding: '10px',
        fontSize: '14px',
        lineHeight: '1.5',
        fontFamily: 'Arial, sans-serif',
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
      }}
    >
      <span style={{ color: '#000' }}>
        <span style={{ color: 'red', fontWeight: 'bold' }}>Disclaimer: </span>
        {expanded ? (
          <>
            {fullText}
            <span
              onClick={toggleExpanded}
              style={{
                color: '#1a73e8',
                cursor: 'pointer',
                marginLeft: '5px',
              }}
            >
              Show Less
            </span>
          </>
        ) : (
          <>
            {briefText}
            <span
              onClick={toggleExpanded}
              style={{
                color: '#1a73e8',
                cursor: 'pointer',
                marginLeft: '5px',
                whiteSpace: 'nowrap',
              }}
            >
              More
            </span>
          </>
        )}
      </span>
    </div>
  );
};

export default Disclaimer;
